import SeoComponent from './SeoComponent'
export default SeoComponent
